import { Filter } from '../../types/types';
import { FilterData } from '../../components/FilterForm/FilterForm';
import { useTranslate } from '../../hooks/context/useTranslate';
import { getDateFilterValuesLabel } from './getDateFilterValuesLabel';

export const getFiltersButtonText = (
  filters: Filter[] | null | undefined,
  filtersData: FilterData[]
) => {
  const { t } = useTranslate();
  let buttonText = t('filter');
  if (!filters || !filters.length) {
    return buttonText;
  }
  const dateFilters = filters.filter(({ type }) =>
    ['DATE', 'DATERANGE'].includes(type)
  );
  if (dateFilters.length === 1) {
    const dateFilterData = filtersData.find(
      ({ id }) => id === dateFilters[0].id
    );
    let dateText = getDateFilterValuesLabel(
      dateFilterData,
      dateFilters[0].type,
      t
    );
    const otherFilterValues = filtersData.find(
      ({ id }) => id !== dateFilters[0].id
    );
    if (otherFilterValues) {
      dateText = `${dateText} + ${t('otherRestrictions')}`;
    }
    buttonText = dateText;
  } else if (filtersData.length !== 0) {
    buttonText = t('activeFilter');
  }
  return buttonText;
};
